// vue-resource interceptor: a 401 means the api_token cookie is gone (e.g. after a
// browser restart), so drop the persisted session and go back to login. The response
// is passed on unchanged, so the caller's .catch still runs.
export default function unauthorizedInterceptor(store, router) {
  return () => (response) => {
    if (response.status !== 401) {
      return;
    }
    store.commit("user/userData", {});
    store.commit("tables/leaveTable");
    store.commit("call/resetCall");
    store.commit("game/exit");
    store.commit("chat/resetChat");
    store.commit("results/resetResults");
    if (router.currentRoute.path !== "/") {
      router.push("/").catch(() => {});
    }
  };
}
